var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "inviteFriends",
      staticClass: "right-body inviteFriends-right-body",
      attrs: { id: "inviteFriends" }
    },
    [
      _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
        _c("div", { staticClass: "inviteFriends-title" }, [
          _c("div", { staticClass: "inviteFriends-center" }, [
            _c("p", [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("language.inviteFriends.titleBefor")) +
                  "\n                "
              ),
              _vm.$i18n.locale == "france"
                ? _c(
                    "span",
                    {
                      staticStyle: { color: "#5065BC", "white-space": "nowrap" }
                    },
                    [_vm._v("2 Go")]
                  )
                : _c(
                    "span",
                    {
                      staticStyle: { color: "#5065BC", "white-space": "nowrap" }
                    },
                    [_vm._v("2 GB")]
                  ),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("language.inviteFriends.titleAfter")) +
                  "\n            "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inviteFriends-line" }),
        _vm._v(" "),
        _c("div", { staticClass: "inviteFriends-boby" }, [
          _c("div", { staticClass: "inviteFriends-center" }, [
            _c("div", { staticClass: "if_emailPic" }, [
              _vm.$i18n.locale == "france"
                ? _c("div", [
                    _c(
                      "span",
                      {
                        staticClass: "inviteFriends-france-emailPic",
                        staticStyle: { "margin-right": "40px" }
                      },
                      [_vm._v("2Go")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "inviteFriends-france-emailPic",
                        staticStyle: { "margin-right": "85px" }
                      },
                      [_vm._v("2Go")]
                    )
                  ])
                : _c("div", [
                    _c(
                      "span",
                      {
                        staticClass: "inviteFriends-france-emailPic",
                        staticStyle: { "margin-right": "40px" }
                      },
                      [_vm._v("2GB")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "inviteFriends-france-emailPic",
                        staticStyle: { "margin-right": "85px" }
                      },
                      [_vm._v("2GB")]
                    )
                  ])
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(_vm._s(_vm.$t("language.inviteFriends.shareEmailTitle")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inviteFriends-block" },
              [
                _c("tags-input", {
                  staticClass: "inviteFriends-email-tags",
                  attrs: {
                    message: _vm.$t("language.inviteFriends.emailTip"),
                    type: "invite"
                  },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingEmail,
                        expression: "loadingEmail"
                      }
                    ],
                    staticClass: "inviteFriends-email-button",
                    on: {
                      click: function($event) {
                        return _vm.shareSendEmail()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.inviteFriends.emailSend")))]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "inviteFriends-block" }, [
              _c("div", { staticClass: "inviteFriends-share-title" }, [
                _vm._v(_vm._s(_vm.$t("language.inviteFriends.shareLinkTitle")))
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "sns-icon facebook inviteFriends-share-icon",
                attrs: {
                  title: _vm.$t(
                    "language.popup.cloudExploerPopup.shareOnFacebook"
                  )
                },
                on: {
                  click: function($event) {
                    return _vm.share($event)
                  }
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "sns-icon twitter inviteFriends-share-icon",
                attrs: {
                  title: _vm.$t(
                    "language.popup.cloudExploerPopup.shareOnTwitter"
                  )
                },
                on: {
                  click: function($event) {
                    return _vm.share($event)
                  }
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "sns-icon tumblr inviteFriends-share-icon",
                attrs: {
                  title: _vm.$t(
                    "language.popup.cloudExploerPopup.shareOnTumblr"
                  )
                },
                on: {
                  click: function($event) {
                    return _vm.share($event)
                  }
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "sns-icon pinterest inviteFriends-share-icon",
                attrs: {
                  title: _vm.$t(
                    "language.popup.cloudExploerPopup.shareOnPinterest"
                  )
                },
                on: {
                  click: function($event) {
                    return _vm.share($event)
                  }
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "sns-icon ins inviteFriends-share-icon",
                attrs: {
                  title: _vm.$t(
                    "language.popup.cloudExploerPopup.shareOnLinkedIn"
                  )
                },
                on: {
                  click: function($event) {
                    return _vm.share($event)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "inviteFriends-share-button",
                  attrs: { title: "Copy invite link" },
                  on: {
                    click: function($event) {
                      return _vm.copySite()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.copyLink")))]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingMsg,
                    expression: "loadingMsg"
                  }
                ],
                staticClass: "msg-loading"
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.user.payLevel != 1,
                        expression: "user.payLevel!=1"
                      }
                    ],
                    staticClass: "inviteFriends-msg"
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("language.inviteFriends.wonMonthFlows")) +
                        "\n                    "
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#5065BC",
                          "font-size": "28px",
                          "white-space": "nowrap"
                        }
                      },
                      [_vm._v(_vm._s(_vm.flow + " GB"))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "if_bg inviteFriends-block",
                    staticStyle: { "margin-top": "0.2rem" }
                  },
                  [
                    _c("div", { staticClass: "inviteFriends-showcase-title" }, [
                      _c("div", { staticStyle: { "max-width": "92%" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("language.inviteFriends.wonMonthTitle"))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inviteFriends-showcase-boby" }, [
                      _c("div", { staticClass: "inviteFriends-showcase_tab" }, [
                        _c(
                          "div",
                          { staticClass: "inviteFriends-showcase_tab_title" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.inviteFriends.lastWinner") +
                                  " (" +
                                  _vm.awardee.oldMouth +
                                  " " +
                                  _vm.awardee.oldYear +
                                  ")"
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "inviteFriends-showcase_tab_msg",
                            staticStyle: { "font-size": "14px" }
                          },
                          [
                            _c("div", { staticStyle: { width: "30%" } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "wonner-email",
                                  attrs: { title: "awardee.awardeeEmail" }
                                },
                                [_vm._v("[" + _vm._s(_vm.awardee.awardeeEmail))]
                              ),
                              _vm._v("]")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "25%",
                                  color: "#5065BC",
                                  "font-weight": "700"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "language.inviteFriends.winnerInvites",
                                      { num: _vm.awardee.inviteSucNum }
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { width: "45%", float: "right" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.inviteFriends.winnerTip")
                                  )
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inviteFriends-showcase_tab" }, [
                        _c(
                          "div",
                          { staticClass: "inviteFriends-showcase_tab_title" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.inviteFriends.statusTitle")
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "inviteFriends-showcase_tab_msg" },
                          [
                            _c("div", { staticStyle: { width: "55%" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.inviteFriends.successInvites"
                                  ) + _vm.userInviteSucNum
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticStyle: { width: "45%" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("language.inviteFriends.chanceWin")
                                )
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#5065BC",
                                    "font-weight": "700"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.userWeight) + " ")]
                              ),
                              _c("span", [_vm._v(_vm._s("/ " + _vm.allWeight))])
                            ])
                          ]
                        )
                      ])
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inviteFriends-block inviteFriends-tips" },
              [
                _c("p", { staticClass: "inviteFriends-tips-title" }, [
                  _vm._v(_vm._s(_vm.$t("language.inviteFriends.tipsTitle")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inviteFriends-tips-msg" }, [
                  _vm._v("1."),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.inviteFriends.tipsOne")))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inviteFriends-tips-msg" }, [
                  _vm._v("2."),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.inviteFriends.tipsTwo")))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "inviteFriends-tips-msg" }, [
                  _vm._v("3."),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.inviteFriends.tipsThird")))
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7aa92f72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aa92f72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/inviteFriends.vue
// module id = null
// module chunks = 